/** Jammable voice changes (owner session cookie): key status + balance, voices, re-voice jobs. */
import axios from "axios";
import { API } from "@/lib/creatorApi";

const http = axios.create({ baseURL: `${API}/jammable`, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const getJammableStatus = () => data(http.get("/status"));
export const searchVoices = (params) => data(http.get("/voices", { params }));
export const myVoices = () => data(http.get("/voices/mine"));
export const addMyVoice = (voice) => data(http.post("/voices/mine", { voice }));
export const removeMyVoice = (id) => data(http.delete(`/voices/mine/${encodeURIComponent(id)}`));
export const startRevoice = (body) => data(http.post("/jobs", body));
export const listRevoices = (params) => data(http.get("/jobs", { params }));
export const markDelivered = (id) => data(http.post(`/jobs/${id}/delivered`));

export const ACTIVE = ["starting", "preparing", "converting", "saving"];
export const PHASES = { starting: "Starting", preparing: "Getting the audio ready", converting: "Changing the voice", saving: "Saving", done: "Done", error: "Stopped" };
export const DASHBOARD = "https://www.jammable.com/developers/dashboard";

/** Same rule as Jammable's billing: $0.25 a minute, by the second, $0.10 minimum. */
export const estimateCost = (sec) => Math.max(0.1, Math.ceil((Math.max(0, sec || 0) / 60) * 25 - 1e-9) / 100);
export const money = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);
